/** Frontmatter for the "week4-start-sit-darkness-report" article; the Body lives in week4-start-sit-darkness-report.jsx. */
const meta = {
  slug: 'week4-start-sit-darkness-report',
  title: 'Week 4 Start/Sit: The Darkness Report',
  category: 'Streaming',
  author: 'Andy Darkness',
  excerpt:
    'All 15 Sunday and Monday games, one card each: start, flex and sit calls, game-time decision callouts, plus a slate board of lines and implied points, an injury board with inactive windows, position tiers, sleepers, the Darkness Rulings and the inactives checklist.',
  readMinutes: 45,
  date: '2026-10-02',
};

export default meta;
